import { useState, useEffect } from 'react';
import { SearchDriverUseCase } from '../../application/useCases';
import { Driver } from '../../domain/entities';

export const useDriverSearch = (
    registration: string,
    clientId: number | null,
    token: string | null
) => {
    const [driver, setDriver] = useState<Driver>(Driver.createUnidentified());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!registration || registration.length < 3 || !clientId || !token) {
            setDriver(Driver.createUnidentified(registration));
            return;
        }

        const searchDriver = async () => {
            try {
                setIsLoading(true);
                const useCase = new SearchDriverUseCase();
                const result = await useCase.execute(registration, clientId, token);
                setDriver(result || Driver.createUnidentified(registration));
            } catch (error) {
                console.error('Error searching driver:', error);
                setDriver(Driver.createUnidentified(registration));
            } finally {
                setIsLoading(false);
            }
        };

        searchDriver();
    }, [registration, clientId, token]);

    return {
        driver,
        isLoading,
    };
};

